// extracted by mini-css-extract-plugin
export var actions = "_qy-5";
export var assistantBubble = "_qy-3";
export var assistantRow = "_qy-6";
export var bubble = "_qy-0";
export var humanAvatar = "_qy-4";
export var inlineToolCard = "_qy-1";
export var userBubble = "_qy-2";